import * as React from 'react';
import { cn } from '@/lib/utils';

const LessonBoard = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-lesson-board', 'flex min-h-[200px] w-full grow flex-col gap-3 rounded-xl border border-solid border-neutral-lightest bg-white p-3 shadow-dropshadow-sm', className)}
    {...props}
  />
));
LessonBoard.displayName = 'LessonBoard';

const LessonBoardHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-lesson-board-header', 'flex flex-wrap content-between items-center gap-4 rounded-sm border-b-2 border-solid border-b-neutral-lightest bg-white p-3 shadow-dropshadow-sm', className)}
    {...props}
  />
));
LessonBoardHeader.displayName = 'LessonBoardHeader';

const LessonBoardBody = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-lesson-board-body', 'flex h-[400px] grow flex-col content-end', className)}
    {...props}
  />
));
LessonBoardBody.displayName = 'LessonBoardBody';

const LessonBoardTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h2
    ref={ref}
    className={cn('c-lesson-board-title', 'mb-0 text-base font-bold text-primary', className)}
    {...props}
  />
));
LessonBoardTitle.displayName = 'LessonBoardTitle';

const LessonBoardFooter = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-lesson-board-footer', 'mt-2 border-t border-solid border-t-neutral-lightest pt-5', className)}
    {...props}
  />
));
LessonBoardFooter.displayName = 'LessonBoardFooter';

const LessonBoardForm = React.forwardRef(({ className, ...props }, ref) => (
  <form
    ref={ref}
    className={cn('c-lesson-board-form', 'flex items-start gap-2', className)}
    {...props}
  />
));
LessonBoardForm.displayName = 'LessonBoardForm';

const LessonBoardRichTextEditor = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-lesson-board-rich-text-editor', 'flex w-28 grow flex-col gap-2', className)}
    {...props}
  />
));
LessonBoardRichTextEditor.displayName = 'LessonBoardRichTextEditor';

const LessonBoardFile = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-lesson-board-file', 'flex items-center gap-2', className)}
    {...props}
  />
));
LessonBoardFile.displayName = 'LessonBoardFile';

const LessonBoardFilePreview = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-lesson-board-file-preview', 'flex max-w-[calc(100%-124px)] shrink items-center gap-3 rounded-sm border border-solid border-neutral-lightest bg-white p-1 py-0.5 text-xs text-neutral-light', className)}
    {...props}
  />
));
LessonBoardFilePreview.displayName = 'LessonBoardFilePreview';

const LessonBoardFileName = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn('c-lesson-board-file-name', 'shrink truncate', className)}
    {...props}
  />
));
LessonBoardFileName.displayName = 'LessonBoardFileName';

export { LessonBoard, LessonBoardHeader, LessonBoardBody, LessonBoardTitle, LessonBoardFooter, LessonBoardForm, LessonBoardRichTextEditor, LessonBoardFile, LessonBoardFilePreview, LessonBoardFileName };
